import { NgModule, LOCALE_ID }      from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { HttpModule, JsonpModule } from '@angular/http';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations'
import { MatProgressSpinnerModule, MatProgressSpinner, MAT_DATE_LOCALE, NativeDateAdapter, DateAdapter, ShowOnDirtyErrorStateMatcher, ErrorStateMatcher, MAT_DATE_FORMATS } from '@angular/material';

import { SidebarModule } from 'ng-sidebar';

import { AppComponent }   from './app.component';
import { AboutComponent } from './core/components/about/about.component';
import { PanicComponent }   from './core/components/panic/panic.component';
import { ChangePasswordDialogComponent } from './core/components/change-password/change-password.component';
import { NotificationAlertComponent }   from './core/components/notification/notification-alert.component';
import { PushNotificationComponent }   from './core/components/notification/notification-native.component';
import { CustomHeaderComponent }   from './core/components/custom-header/custom-header.component';
import { PageNotFoundComponent }   from './core/components/page-not-found/page-not-found.component';

import { CustomFooterComponent }   from './core/components/custom-footer/custom-footer.component';
import { MenuSelectorModuleComponent } from './core/components/menu-selector-module/menu-selector-module.component'

import { AppRoutingModule } from './app.routing.module';
import { SharedModule } from './shared/shared.module';
import { Platform } from '@angular/cdk/platform';
import { CURRENCY_MASK_CONFIG, CurrencyMaskConfig } from 'ng2-currency-mask/src/currency-mask.config';
//import { OverlayContainer, FullscreenOverlayContainer, OverlayModule } from '@angular/cdk/overlay';


import { registerLocaleData } from '@angular/common';
import ptBr from '@angular/common/locales/pt';
import { OverlayModule } from '@angular/cdk/overlay';

import { CookieService } from 'ngx-cookie-service';
registerLocaleData(ptBr)


export function platformProviderFactory() {
    return () => new Platform();
  }
  
  
  
  export class AppDateAdapter extends NativeDateAdapter {
    parse(value: any): Date | null {
     if ((typeof value === 'string') && (value.indexOf('/') > -1)) {
       const str = value.split('/');
       const year = Number(str[2]);
       const month = Number(str[1]) - 1;
       const date = Number(str[0]);
       return new Date(year, month, date);
     }
     const timestamp = typeof value === 'number' ? value : Date.parse(value);
     return isNaN(timestamp) ? null : new Date(timestamp);
   }
  
    format(date: Date, displayFormat: Object): string {
        if (displayFormat == "input") {
            let day = date.getDate();
            let month = date.getMonth() + 1;
            let year = date.getFullYear();
            return this._to2digit(day) + '/' + this._to2digit(month) + '/' + year;
        } else {
            return date.toDateString();
        }
    }
  
    private _to2digit(n: number) {
        return ('00' + n).slice(-2);
    } 
  }
  
  
  export const APP_DATE_FORMATS =
  {
    parse: {
        dateInput: {month: 'short', year: 'numeric', day: 'numeric'}
    },
    display: {
        // dateInput: { month: 'short', year: 'numeric', day: 'numeric' },
        dateInput: 'input',
        monthYearLabel: { month: 'short', year: 'numeric', day: 'numeric' },
        dateA11yLabel: {year: 'numeric', month: 'long', day: 'numeric'},
        monthYearA11yLabel: {year: 'numeric', month: 'long'},
    }
  }
  
  
  export const CustomCurrencyMaskConfig: CurrencyMaskConfig = {
    align: "right",
    allowNegative: true,
    allowZero: true,
    decimal: ",",
    precision: 2,
    prefix: "",
    suffix: "",
    thousands: "."
  };

@NgModule({
  imports:      [ 
      BrowserModule,
      SharedModule.forRoot(),
      HttpModule,
      BrowserAnimationsModule,
      SidebarModule.forRoot(),
      AppRoutingModule
  ],
  exports: [
  ],
  declarations: [ 
      AppComponent,
      AboutComponent,
      ChangePasswordDialogComponent, 
      CustomHeaderComponent,
      CustomFooterComponent,
      MenuSelectorModuleComponent,
      NotificationAlertComponent,
      PageNotFoundComponent ],
  bootstrap: [ AppComponent ],
  entryComponents: [ ChangePasswordDialogComponent ],
  providers: [
    CookieService,
    // { provide: LOCALE_ID, useValue: 'pt-PT' },
    //{ provide: Platform, useFactory: platformProviderFactory, multi: false },
    { provide: DateAdapter, useClass: AppDateAdapter, deps: [MAT_DATE_LOCALE]},
    { provide: MAT_DATE_LOCALE, useValue: 'pt-BR'},
    { provide: MAT_DATE_FORMATS, useValue: APP_DATE_FORMATS},
    // { provide: ErrorStateMatcher, useClass: ShowOnDirtyErrorStateMatcher},
    { provide: CURRENCY_MASK_CONFIG, useValue: CustomCurrencyMaskConfig }
    //{provide: OverlayContainer, useClass: FullscreenOverlayContainer}],
  ]
})

export class AppModule { 
    
}






// WEBPACK FOOTER //
// ./node_modules/angular-router-loader/src!./node_modules/angular2-template-loader?keepUrl=true!./app/app.module.ts